// extracted by mini-css-extract-plugin
module.exports = {"create-campaign":"styles_create-campaign__20cst","tab":"styles_tab__2fIxc","header":"styles_header__NZDMH","status":"styles_status__3e_Zf","title":"styles_title__1Mc4H"};